
const NotFound = () => {
  return (
    <>
        <h1 style={{textAlign: "center"}}>404 - Not Authorised To View This Page.</h1>
    </>
  )
}

export default NotFound
